// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"125":"c80eca1e8cdaf5b93982","676":"c66e5be8c059e8941439","678":"54424224cf2c8f9741c2","785":"0ce8e44625dc343c698c"}[chunkId] + ".js";
};